<template>
  <div class="Activities">
    <confirm ref="confirm"></confirm>
    <v-progress-linear
      v-show="progressBar"
      slot="progress"
      color="blue"
      indeterminate
    />

    <v-container class="my-1">
      <v-layout row Wrap>
        <v-flex xs12 sm12 lg12
          ><v-card-text
            v-text="PageTitle"
            class="subtitle-1 grey--text"
          ></v-card-text>
        </v-flex>
      </v-layout>

      <v-data-table
        :hide-default-footer="true"
        :disable-pagination="true"
        :disable-sort="true"
        :disable-filtering="true"
        :items="activities"
        :headers="headers"
        item-key="Activity_id"
        @click:row="gotoactivity"
      >
        <template v-slot:top>
          <v-row >
            <v-flex xs6 sm6 lg6>
              <v-text-field
                v-model="activitysearch"
                prepend-icon="mdi-magnify"
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs1 sm1 lg1></v-flex>

            <v-flex xs4 sm4 lg4 align-self-center>
                            <div class="text-center d-flex align-center justify-space-around">

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      @click="refreshlist"
                      medium
                      color="green darken-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-refresh
                    </v-icon>
                  </template>
                  <span>Refresh </span>
                </v-tooltip>
            
              <v-dialog v-model="filterdialog" max-width="600px" persistent>
                  <template v-slot:activator="{ on: dialog }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-icon v-bind="attrs" v-on="{ ...tooltip, ...dialog }">
                          mdi-filter-menu</v-icon
                        >
                      </template>
                      <span>Filters</span>
                    </v-tooltip>
                  </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">Activity Search Filters</span>
                  </v-card-title>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-combobox
                          v-model="sortbyfield"
                          :items="sortbyfields"
                          label="Sort By"
                          multiple
                          outlined
                          dense
                          clearable
                        ></v-combobox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-combobox
                          v-model="typefield"
                          :items="typefields"
                          label="Filter Type"
                          multiple
                          outlined
                          dense
                          clearable
                        ></v-combobox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-combobox
                          v-model="completedfield"
                          :items="completedfields"
                          label="Filter Completed"
                          multiple
                          outlined
                          dense
                          clearable
                        ></v-combobox>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menufrom"
                          v-model="menufrom"
                          :close-on-content-click="false"
                          :return-value.sync="datefrom"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="datefrom"
                              label="From Activity Date"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              clearable
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="datefrom" no-title scrollable>
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menufrom.save('')"
                            >
                              Clear
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menufrom.save(datefrom)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-col>

                      <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menuto"
                          v-model="menuto"
                          :close-on-content-click="false"
                          :return-value.sync="dateto"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="dateto"
                              label="To Activity Date"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              clearable
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="dateto" no-title scrollable>
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menuto.save('')"
                            >
                              Clear
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menuto.save(dateto)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-container>

                  <v-card-actions>
                    <v-btn color="blue darken-1" text @click="refreshlist">
                      Done
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
                            </div>
            </v-flex>
          </v-row>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import Confirm from "@/components/Confirm";
export default {
  components: { Confirm },
  data() {
    return {
      loadformfields: true,
      activitysearch: "",
      PageTitle: "Search " + localStorage.getItem("CURPROFILE") + " Activities",
      activities: [],
      sortbyfields: ["Company Name", "Type", "Activity Date"],
      typefields: [],
      completedfields: ["Completed","Incomplete"],
      filterdialog: false,
    };
  },

  computed: {
    headers() {
      return [
        { text: "Company Name", value: "Company_Name" },
        { text: "Activity Date", value: "Adate" },
        { text: "Type", value: "Atype" },
        { text: "Notes", value: "Anote" },
        { text: "Completed", value: "Acompleted" },
      ];
    },
  },

  created() {
    this.refreshlist();
  },

  methods: {
    async refreshlist() {
      this.filterdialog = false;
      this.activities = [];
      this.typefields = [];
      this.progressBar = true;
      this.myJsonResp = await this.PostData(
        "ActivitiesList",
        JSON.stringify({
          curprofile: localStorage.getItem("CURPROFILE"),
          loadformfields: this.loadformfields,
          activitysearch: this.activitysearch,
          sortbyfield: this.sortbyfield,
          typefield: this.typefield,
          completedfield: this.completedfield,
          datefrom: this.datefrom,
          dateto: this.dateto,
        })
      );

      this.progressBar = false;
      if (this.myJsonResp != "ERROR") {
        this.loadformfields = false;
        this.data = JSON.parse(this.myJsonResp);
                        this.PageTitle = "Search " + localStorage.getItem("CURPROFILE") + " Activities - " + this.data["ResultCount"] + " Results "; 

        this.activities = this.data["ACTIVITIES"];
        this.typefields = this.data["ATYPES"];
        this.formfields = JSON.parse(this.data["FORMFIELDS"]);
        this.activitysearch = this.formfields["activitysearch"];
        this.sortbyfield = this.formfields["sortbyfield"];
        this.typefield = this.formfields["typefield"];
        this.completedfield = this.formfields["completedfield"];
        this.dateto = this.formfields["dateto"];
      }
    },

    gotoactivity(row) {
      this.$router.push("/Activity/" + row.Company_ID + "/Activity_id/" + row.Activity_id );
    },
  },
};
</script>
